import React, { Component } from 'react'
import { Footer } from '../../healtheraComponents'

export default class HealtheraFooter extends Component {

  render() {
    const { bordertop, margin } = this.props
    return (
      <Footer bordertop={bordertop} margin={margin}>
        <span color={`red`}>© 2019-{new Date().getFullYear()} Healthera Ltd. is a company registered in England and Wales with company number 9609198</span>
        <span><a target="_blank" rel='noopener noreferrer' href="https://www.healthera.co.uk/privacy">Privacy</a> | <a target="_blank" rel='noopener noreferrer' href="https://www.healthera.co.uk/pharmacy-terms">Terms of Use</a></span>
      </Footer>
    )
  }
}
